<template>
  <div class="wrp">
    <BindLeadAndSocialLead :socialLeadId="socialLeadId" :tutorChatToken="tutorChatToken"></BindLeadAndSocialLead>
  </div>
</template>

<script>
import BindLeadAndSocialLead from "../components/Main/BindLeadAndSocialLead.vue";

export default {
  components: {
    BindLeadAndSocialLead
  },
  data() {
    return {
      mode: {
        type: "PC",
        token: "",
        staff: []
      },
    };
  },
  created() {
    document.title = "綁定一般名單";
    this.tutorChatToken = this.$route.query.tct;
    this.socialLeadId = this.$route.query.sli;
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/MobileBindLeadAndSocialLeadView.vue